<template>
  <div>
    <div class="header">
      <img src="../../assets/images/mine/1.png">
      <div class="sy-cell avterbox" @click="linkInfo">
        <img v-lazy="info.headUrl" class="headerImg">
        <div class="font18 fontweight">
          {{ info.name }}
        </div>
      </div>
      <div class="sy-cell_around cardCar">
        <div v-for="(item,index) in orderList" :key="index" class="sy-cell cell-column">
          <img :src="item.images" class="icon">
          <div>
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <van-cell-group>
        <van-cell v-for="(item,index) in userList" :key="index" border is-link to="/mine/info">
          <template slot="title">
            <img
              :src="item.images"
              class="icon2"
            >
            <span class="custom-text">{{ item.text }}</span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { fetchUserInfo } from '@/api/mine'

export default {
  data() {
    return {
      info: {},
      orderList: [
        {
          images: require('../../assets/images/mine/2.png'),
          text: '待付款'
        },
        {
          images: require('../../assets/images/mine/3.png'),
          text: '待发货'
        },
        {
          images: require('../../assets/images/mine/4.png'),
          text: '待收货'
        },
        {
          images: require('../../assets/images/mine/5.png'),
          text: '评价'
        },
        {
          images: require('../../assets/images/mine/6.png'),
          text: '我的订单'
        }
      ],
      userList: [
        {
          images: require('../../assets/images/mine/7.png'),
          text: '我的积分'
        },
        {
          images: require('../../assets/images/mine/8.png'),
          text: '购物车'
        },
        {
          images: require('../../assets/images/mine/9.png'),
          text: '收货地址'
        },
        {
          images: require('../../assets/images/mine/9.png'),
          text: '基本信息',
          url: '/mine/info'
        },
        {
          images: require('../../assets/images/mine/10.png'),
          text: '我的设备'
        },
        {
          images: require('../../assets/images/mine/11.png'),
          text: '清除缓存'
        },
        {
          images: require('../../assets/images/mine/12.png'),
          text: '版本管理'
        },
        {
          images: require('../../assets/images/mine/13.png'),
          text: '联系客服'
        },
        {
          images: require('../../assets/images/mine/14.png'),
          text: '关于我们'
        }
      ]
    }
  },
  created() {
    fetchUserInfo({}).then(res => {
      this.info = res.data.data
    })
  },
  methods: {
    linkInfo() {
      this.$router.push('/mine/info')
    }
  }
}
</script>

<style scoped lang="scss">
.header{
  width:100%;
  height: 194px;
  img{
    width: 100%;
    height:100%;
  }
  .avterbox{
    padding-left:18px;
    position: absolute;
    top: 37px;
    .headerImg{
      width:70px;
      height:70px;
      border-radius: 50%;
      padding:2px;
      background: #f5f5f5;
      margin-right:15px;
    }
  }
}
.cardCar{
  width: 92%;
  height: 73px;
  background: #fff;
  box-shadow: 0 4px 8px 1px #eee;
  position: absolute;
  top:122px;
  left:4%;
  color:#666;
  .icon{
    width: 18px;
    height:16px;
    margin-bottom:10px;
  }
}
.footer{
  margin-top: 10px;
  .van-cell__title{
  display: flex;
  align-items: center;
  .icon2{
  width: 17px;
  height:auto;
  margin-right: 12.5px;
}
}
  .van-cell:nth-child(3){
    border-bottom: 10px solid #f5f5f5;
  }
}

</style>
